import { forEach } from 'ramda';

const keyMirror = list => {
  const result = {};

  forEach(item => {
    result[item] = item;

    if (item.includes('FETCH') || item.includes('PROMISE')) {
      result[`${item}_START`] = `${item}_START`;
      result[`${item}_ERROR`] = `${item}_ERROR`;
      result[`${item}_SUCCESS`] = `${item}_SUCCESS`;
    }
  }, list);

  return result;
};

export default keyMirror;
